import React from 'react'
import { Image } from '@sainsburys-tech/bolt'

import Dimension from './components/Dimension'
import * as Styled from './HabitatDimensions.styles'

const HabitatDimensions = props => {
  const { dataTest, lineDrawing, dimensions } = props
  const imageProps = {
    src: lineDrawing,
    alt: 'Line Drawing',
    width: 300,
    height: 300,
    quality: 75
  }
  const { attributes } = dimensions
  return (
    <Styled.DimensionContainer>
      <Styled.DimensionDetailsContainer>
        <Styled.BannerContainer data-test={`${dataTest}-banner`}>
          <Image {...imageProps} />
        </Styled.BannerContainer>
        <Styled.DimensionInfomation>
          <Styled.DimensionsDetails>
            {attributes.size && <Dimension label='Assembled Dimensions' value={attributes.size} />}
            {attributes.seatHeight && <Dimension label='Seat Height' value={attributes.seatHeight} />}
            {attributes.seatingAreaWidth && <Dimension label='Diagonal Depth' value={attributes.seatingAreaWidth} />}
            {attributes.seatDepth && <Dimension label='Seat Depth' value={attributes.seatDepth} />}
            {attributes.packageSizeOne && <Dimension label='Packaged Dimension' value={attributes.packageSizeOne} />}
          </Styled.DimensionsDetails>
        </Styled.DimensionInfomation>
      </Styled.DimensionDetailsContainer>
    </Styled.DimensionContainer>
  )
}

export default HabitatDimensions
